/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { z } from 'zod/v4'

export const updateOrganisationAtsAutomationSettingsDataSchema = z.object({
	autoGenerateCampaigns: z.boolean().optional(),
	autoCloseCampaigns: z.boolean().optional(),
})

export type UpdateOrganisationAtsAutomationSettingsDataSchema = z.infer<
	typeof updateOrganisationAtsAutomationSettingsDataSchema
>
